// Carry Roll OptimizationTriangle — speed/launch/spin efficiency frontier (9.4).

import { useMemo } from 'react';
import { useRequest } from '../../store/selectors';
import { optimizationTriangle } from '@carry-roll/shared-logic';
import { HelpTooltip } from '../calculator/HelpTooltip';

export function OptimizationTriangle() {
  const request = useRequest();
  const tri = useMemo(() => optimizationTriangle(request), [request]);

  const balancePct = Math.round(tri.balance * 100);

  return (
    <div data-testid="optimization-triangle">
      <h3 className="subsection-title">
        Optimization triangle
      </h3>
      <p className="text-sm mb-3" style={{ color: 'var(--color-text-muted)' }}>
        Speed / launch / spin balance.
      </p>
      <div className="grid grid-cols-3 gap-2 text-center">
        <TriangleStat label="Ball speed" value={`${tri.ballSpeed.toFixed(1)}`} unit="m/s" />
        <TriangleStat label="Launch" value={`${tri.launchAngle.toFixed(1)}`} unit="°" />
        <TriangleStat label="Spin" value={`${tri.spin.toFixed(0)}`} unit="rpm" />
      </div>
      <div className="mt-3">
        <div className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
          Balance score
          <HelpTooltip label="Balance score">How close ball speed, launch, and spin are to their optimum combination for this ball speed. 100% is optimal.</HelpTooltip>
        </div>
        <div
          style={{
            height: '10px',
            background: 'var(--color-border)',
            borderRadius: '5px',
            marginTop: '2px',
          }}
        >
          <div
            style={{
              width: `${balancePct}%`,
              height: '100%',
              borderRadius: '5px',
              background: balancePct > 70 ? 'var(--color-success)' : balancePct > 40 ? 'var(--color-warn)' : 'var(--color-danger)',
            }}
          />
        </div>
        <div className="text-xs mt-1" style={{ color: 'var(--color-text-muted)' }}>
          {balancePct}% optimal
        </div>
      </div>
    </div>
  );
}

function TriangleStat({ label, value, unit }: { label: string; value: string; unit: string }) {
  return (
    <div>
      <div className="field-label">{label}</div>
      <div className="text-lg font-medium">
        {value}
      </div>
      <div className="text-xs" style={{ color: 'var(--color-text-muted)' }}>
        {unit}
      </div>
    </div>
  );
}
